class RevisitConsent {
    constructor() {
        const lists = document.querySelectorAll(
            '.footer-contact-navigation-list'
        );

        this.finalList = lists[lists.length - 1];

        if (!this.finalList) {
            return;
        }

        if (this.finalList.querySelector('.cky-banner-element')) {
            return;
        }

        this.appendRevisit();
    }

    appendRevisit() {
        const li = document.createElement('li');

        li.innerHTML = `
            <button 
                class="footer-link cky-banner-element"
            >
                Cookie Settings
            </button>
        `;

        this.finalList.appendChild(li);
    }
}

new RevisitConsent();